import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

import { DashboardReportComponent } from "../../reports/dashboard-reports/dashboard-report/dashboard-report.component";

@Component({
  selector: "app-project-dashboard",
  templateUrl: "./project-dashboard.component.html",
  styleUrls: ["./project-dashboard.component.scss"],
})
export class ProjectComponent implements OnInit, OnDestroy {
  @ViewChild("projectReport") projectReport?: DashboardReportComponent;

  private destroy$ = new Subject<void>();

  id = "";
  projectName = "Project Report";
  shouldAutoPdfDownload = false;
  isIssuesDrawerOpen = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        map((params) => params.get("id") || ""),
        takeUntil(this.destroy$)
      )
      .subscribe((id) => {
        this.id = id;
      });

    this.route.queryParamMap
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.shouldAutoPdfDownload = params.get("isPdfDownload") === "true";
      });
  }

  downloadPdf(): void {
    if (this.projectReport?.reportUnavailable) return;
    this.projectReport?.downloadPdf();
  }

  onReportLoaded(report: { projectId: string; projectName: string }): void {
    this.id = report.projectId || this.id;
    this.projectName = report.projectName || this.projectName;
  }

  viewProjectIssuesList(): void {
    this.isIssuesDrawerOpen = true;
  }

  closeIssuesDrawer(): void {
    this.isIssuesDrawerOpen = false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
